import { Box, Container, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Wordmark } from "./Wordmark";
import { navLinks } from "./NavBar";

export function Footer() {
  return (
    <Box component="footer" sx={{ borderTop: "1px solid", borderColor: "divider", py: { xs: 6, md: 8 } }}>
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={4}
          sx={{ alignItems: "center", justifyContent: "space-between" }}
        >
          <Wordmark />

          <Stack component="nav" direction="row" spacing={3} useFlexGap sx={{ flexWrap: "wrap", justifyContent: "center" }}>
            {navLinks.map(({ to, label }) => (
              <Box
                key={to}
                component={RouterLink}
                to={to}
                sx={{ color: "text.secondary", textDecoration: "none", fontSize: 14, "&:hover": { color: "primary.main" } }}
              >
                {label}
              </Box>
            ))}
          </Stack>
        </Stack>

        <Typography sx={{ mt: 5, textAlign: "center", fontSize: 13, color: "text.secondary", opacity: 0.7 }}>
          © {new Date().getFullYear()} Groowv Electric Band. Todos os direitos reservados.
        </Typography>
      </Container>
    </Box>
  );
}
